import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLoginUserStore = defineStore(
  'loginUser',
  () => {
    const loginUser = ref({
      userName: '未登录',
      userRole: 'notLogin'
    })

    async function getLoginUserInfo() {
      try {
        const { getCurrentUser } = await import('@/api/yonghuguanli')
        const res = await getCurrentUser()
        if (res.code === 0 && res.data) {
          loginUser.value = res.data
        }
      } catch (e) {
        console.error('获取用户信息失败', e)
      }
    }

    function setLoginUserInfo(user) {
      loginUser.value = user
    }

    return { loginUser, getLoginUserInfo, setLoginUserInfo }
  },
  {
    persist: true
  }
)